const NavBarItem = ({ children }: any) => (
  <div className="NavBarItem">
    <div className="NavBarItem__icon">/</div>
    {children}
  </div>
);

export default NavBarItem;
